export default {"src":"/_next/static/media/elment2.da159f59.svg","height":62,"width":91,"blurWidth":0,"blurHeight":0};